// components/MediaSection.js
import React, { useCallback } from 'react';
import FileUploader from '../../FileUploader/FileUploader';
// import FloorPlanUrls from './FloorPlanUrls';

const MediaSection = ({
    media,
    setMedia,
    formData,
    handleInputChange,
    floorPlanUrls,
    setFloorPlanUrls,
    propertyTypeSelectedFields,
    errors
}) => {
    const validatePropertyImages = useCallback((newFiles) => {
        const totalAfterUpload = media.length + newFiles.length;
        if (totalAfterUpload > 15) {
            alert(`Cannot upload ${newFiles.length} files. You currently have ${media.length} images. Maximum 15 images allowed for property images. You can only upload ${15 - media.length} more.`);
            return false;
        }
        return true;
    }, [media.length]);

    const validateFloorPlanImages = useCallback((newFiles) => {
        const totalAfterUpload = floorPlanUrls.length + newFiles.length;
        if (totalAfterUpload > 10) {
            alert(`Cannot upload ${newFiles.length} files. You currently have ${floorPlanUrls.length} images. Maximum 10 images allowed for floor plan. You can only upload ${10 - floorPlanUrls.length} more.`);
            return false;
        }
        return true;
    }, [floorPlanUrls.length]);

    const handleMediaChange = (newFiles) => {
        setMedia(newFiles);
    };

    const handleFloorPlanChange = (newFiles) => {
        setFloorPlanUrls(newFiles);
    };

    return (
        <>
            <div className="dropzone-admin mb-3 mt-3">
                <label className="form-label">Property Images <span className="text-danger">*</span> <span className="text-muted">(Max: 15 images)</span></label>
                <FileUploader
                    files={media}
                    onFilesChange={handleMediaChange}
                    validateBeforeUpload={validatePropertyImages}
                    multiple={true}
                    acceptImagesOnly={true}
                    uploadText="Upload Property Images"
                />
                {errors?.media && <div className="text-danger small mt-1">{errors.media}</div>}
                <div className="text-muted small mt-1">{media.length}/15 images uploaded</div>
            </div>

            <div className="mb-3 col-12">
                <label className="form-label">Video URL (YouTube)</label>
                <input
                    type="text"
                    className="form-control"
                    placeholder="Video URL (YouTube)"
                    value={formData.videoUrl}
                    onChange={(e) => handleInputChange('videoUrl', e.target.value)}
                />
            </div>

            <div className="dropzone-admin mb-3">
                <label className="form-label mb-2">Upload Floor Plan Images <span className="text-muted">(Max: 10 images)</span></label>
                <FileUploader
                    files={floorPlanUrls}
                    onFilesChange={handleFloorPlanChange}
                    validateBeforeUpload={validateFloorPlanImages}
                    multiple={true}
                    acceptImagesOnly={true}
                    uploadText="Upload Floor Plan Images"
                />
                <div className="text-muted small mt-1">{floorPlanUrls.length}/10 images uploaded</div>
            </div>
        </>
    );
};

export default MediaSection;
